import React, { useState, useEffect,useCallback } from "react";
import api from "../../../services/httpService";
import "./ContactSections.css";

const ContactManagement = () => {
  const [contactData, setContactData] = useState({
    title: "", description: "", Imagekey: "", Address: "",
    Email: "", Phone: "", WhatsappNumber: "", Instagram: "",
    Facebook: "", Twitter: "", Linkedin: "", GitHub: "", MapEmbedLink: "",
  });

  const [isLoadingForm, setIsLoadingForm]   = useState(true);
  const [isSavingForm, setIsSavingForm]     = useState(false);
  const [formMessage, setFormMessage]       = useState("");
  const [isEditingForm, setIsEditingForm]   = useState(false);
  const [contactExists, setContactExists]   = useState(false);
  const [imagePreview, setImagePreview]     = useState(null);
  const [selectedImage, setSelectedImage]   = useState(null);

  const [submissions, setSubmissions]               = useState([]);
  const [isLoadingSubmissions, setIsLoadingSubmissions] = useState(true);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [isModalOpen, setIsModalOpen]               = useState(false);
  const [submissionMessage, setSubmissionMessage]   = useState("");

  const [currentPage, setCurrentPage]   = useState(1);
  const [totalCount, setTotalCount]     = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => { fetchContactData(); }, []);
  //useEffect(() => { fetchSubmissions(); }, [currentPage, itemsPerPage]);

  // ==================== CONTACT INFO ====================
  const fetchContactData = async () => {
    setIsLoadingForm(true);
    try {
      const res = await api.get("/sentinix/contactforms");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const contactInfo = allData.find(
          item => item.title !== null && item.title !== undefined && item.title !== ""
        );
        if (contactInfo) { setContactData(contactInfo); setContactExists(true); }
        else { setContactExists(false); }
      }
    } catch (err) {
      if (err.response?.status === 404) setContactExists(false);
    } finally {
      setIsLoadingForm(false);
    }
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedImage(file);
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSaveForm = async () => {
    if (!contactData.title?.trim() || !contactData.description?.trim() ||
        !contactData.Email?.trim() || !contactData.Phone?.trim()) {
      setFormMessage("Title, Description, Email, and Phone are required");
      return;
    }
    setIsSavingForm(true);
    try {
      const formData = new FormData();
      Object.keys(contactData).forEach(key => {
        if (key !== "Imagekey") formData.append(key, contactData[key] || "");
      });
      if (selectedImage) {
        formData.append("Imagekey", selectedImage);
      } else if (contactData.Imagekey && typeof contactData.Imagekey === "string") {
        formData.append("Imagekey", contactData.Imagekey);
      }

      let res;
      if (contactExists) {
        res = await api.put(`/sentinix/contactforms/${contactData.id}`, formData,
          { headers: { "Content-Type": "multipart/form-data" } });
      } else {
        res = await api.post("/sentinix/contactforms", formData,
          { headers: { "Content-Type": "multipart/form-data" } });
      }

      if (res.data.success) {
        setFormMessage("Contact data saved successfully!");
        fetchContactData();
        setIsEditingForm(false);
        setSelectedImage(null);
        setImagePreview(null);
      }
    } catch (err) {
      setFormMessage("Error saving contact data");
    } finally {
      setIsSavingForm(false);
      setTimeout(() => setFormMessage(""), 3000);
    }
  };

  // ==================== SUBMISSIONS — NEW API ====================
  // const fetchSubmissions = async () => {
  //   setIsLoadingSubmissions(true);
  //   try {
  //     const offset = (currentPage - 1) * itemsPerPage;
  //     const res = await api.get(
  //       `/sentinix/contactsubmission?limit=${itemsPerPage}&offset=${offset}`
  //     );
  //     if (res.data.success) {
  //       const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
  //       setSubmissions(allData);
  //       setTotalCount(res.data.totalCount || res.data.total || allData.length);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching submissions:", err);
  //   } finally {
  //     setIsLoadingSubmissions(false);
  //   }
  // };

  const fetchSubmissions = useCallback(async () => {
  setIsLoadingSubmissions(true);
  try {
    const offset = (currentPage - 1) * itemsPerPage;
    const res = await api.get(
      `/sentinix/contactsubmission?limit=${itemsPerPage}&offset=${offset}`
    );

    if (res.data.success) {
      const allData = Array.isArray(res.data.data)
        ? res.data.data
        : [res.data.data];

      setSubmissions(allData);
      setTotalCount(res.data.totalCount || res.data.total || allData.length);
    }
  } catch (err) {
    console.error("Error fetching submissions:", err);
  } finally {
    setIsLoadingSubmissions(false);
  }
}, [currentPage, itemsPerPage]);

useEffect(() => {
  fetchSubmissions();
}, [fetchSubmissions]);

  const handleDeleteSubmission = async (id) => {
    if (!window.confirm("Are you sure you want to delete this submission?")) return;
    try {
      await api.delete(`/sentinix/contactsubmission/${id}`);
      setSubmissionMessage("Submission deleted successfully");
      fetchSubmissions();
      closeModal();
    } catch (err) {
      setSubmissionMessage("Error deleting submission");
    } finally {
      setTimeout(() => setSubmissionMessage(""), 3000);
    }
  };

  const openModal  = (s) => { setSelectedSubmission(s); setIsModalOpen(true); };
  const closeModal = ()  => { setSelectedSubmission(null); setIsModalOpen(false); };

  const formatDate = (d) => new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit", month: "2-digit", year: "numeric"
  });

  const totalPages       = Math.ceil(totalCount / itemsPerPage);
  const goToPreviousPage = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
  const goToNextPage     = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };

  const getName    = (s) => s.name    || s.Name    || "-";
  const getEmail   = (s) => s.Email   || s.email   || "-";
  const getPhone   = (s) => s.Phone   || s.phone   || "-";
  const getService   = (s) => s.service   || s.service   || "-";
  const getMessage = (s) => s.Message || s.message || "-";

  return (
    <div className="contact-mgmt-container">
      <div className="contact-page-header">
        <h1>Contact Management</h1>
      </div>

      {/* ==================== CONTACT INFO CARD ==================== */}
      <div className="contact-form-card">
        <div className="contact-form-header">
          <div><h2>Contact Information</h2></div>
          {!isLoadingForm && contactExists && (
            <button onClick={() => setIsEditingForm(!isEditingForm)}
              className={`btn-toggle-edit ${isEditingForm ? "cancel" : "edit"}`}>
              {isEditingForm ? "✕ Cancel" : "✏️ Edit"}
            </button>
          )}
        </div>

        {isLoadingForm ? (
          <div className="loading-box"><div className="spinner" /><p>Loading contact data...</p></div>
        ) : (
          <>
            {formMessage && (
              <div className={`form-message ${formMessage.includes("success") ? "success" : "error"}`}>
                {formMessage}
              </div>
            )}

            {/* Hero Section */}
            <div className="form-section">
              <h3 className="form-section-title">Hero Section</h3>
              <div className="form-grid">
                <div className="form-group-contact">
                  <label>Title <span className="required">*</span></label>
                  <input type="text" value={contactData.title || ""}
                    onChange={e => setContactData({ ...contactData, title: e.target.value })}
                    readOnly={!isEditingForm && contactExists}
                    placeholder="Enter contact page title"
                    className={`form-input-contact ${!isEditingForm && contactExists ? "readonly" : ""}`} />
                </div>
                <div className="form-group-contact full-width">
                  <label>Description <span className="required">*</span></label>
                  <textarea value={contactData.description || ""}
                    onChange={e => setContactData({ ...contactData, description: e.target.value })}
                    readOnly={!isEditingForm && contactExists} rows={4}
                    placeholder="Enter contact page description"
                    className={`form-textarea-contact ${!isEditingForm && contactExists ? "readonly" : ""}`} />
                </div>
                <div className="form-group-contact full-width">
                  <label>Image</label>
                  {(contactData.Imagekey || imagePreview) && (
                    <div className="image-preview-contact">
                      <img src={imagePreview || contactData.Imagekey} alt="Contact" />
                    </div>
                  )}
                  {(isEditingForm || !contactExists) && (
                    <div className="image-upload-contact">
                      <input type="file" accept="image/*" onChange={handleImageSelect} className="file-input-contact" />
                      {selectedImage && <p className="image-note">{selectedImage.name} — will upload on Save</p>}
                      {!selectedImage && contactData.Imagekey && <p className="image-note">Existing image will be kept</p>}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Contact Details */}
            <div className="form-section">
              <h3 className="form-section-title">Contact Details</h3>
              <div className="form-grid">
                {[
                  { label: "Address", key: "Address", type: "textarea", rows: 3, placeholder: "Enter complete address", full: true },
                  { label: "Email *", key: "Email", type: "email", placeholder: "contact@example.com" },
                  { label: "Phone *", key: "Phone", type: "tel", placeholder: "Contact Number", maxLength: 10 },
                  { label: "WhatsApp Number", key: "WhatsappNumber", type: "tel", placeholder: "WhatsApp Number", maxLength: 10 },
                  { label: "Instagram", key: "Instagram", type: "text", placeholder: "Instagram URL" },
                  { label: "Facebook",  key: "Facebook",  type: "text", placeholder: "Facebook URL" },
                  { label: "Twitter",   key: "Twitter",   type: "text", placeholder: "Twitter URL" },
                  { label: "LinkedIn",  key: "Linkedin",  type: "text", placeholder: "LinkedIn URL" },
                  { label: "GitHub",    key: "GitHub",    type: "text", placeholder: "GitHub URL" },
                  { label: "Map Embed Link", key: "MapEmbedLink", type: "textarea", rows: 3, placeholder: "<iframe ...>", full: true, mono: true },
                ].map(field => (
                  <div key={field.key} className={`form-group-contact ${field.full ? "full-width" : ""}`}>
                    <label>{field.label}</label>
                    {field.type === "textarea" ? (
                      <textarea value={contactData[field.key] || ""}
                        onChange={e => setContactData({ ...contactData, [field.key]: e.target.value })}
                        readOnly={!isEditingForm && contactExists} rows={field.rows}
                        placeholder={field.placeholder}
                        className={`form-textarea-contact ${field.mono ? "mono" : ""} ${!isEditingForm && contactExists ? "readonly" : ""}`} />
                    ) : (
                      <input type={field.type} value={contactData[field.key] || ""}
                        onChange={e => setContactData({ ...contactData, [field.key]: e.target.value })}
                        readOnly={!isEditingForm && contactExists}
                        placeholder={field.placeholder}
                        maxLength={field.maxLength}
                        className={`form-input-contact ${!isEditingForm && contactExists ? "readonly" : ""}`} />
                    )}
                  </div>
                ))}
              </div>
            </div>

            {(isEditingForm || !contactExists) && (
              <div className="form-save-footer">
                <button onClick={handleSaveForm} disabled={isSavingForm} className="btn-save-contact">
                  {isSavingForm ? "Saving..." : contactExists ? "💾 Update Contact Data" : "💾 Create Contact Data"}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* ==================== SUBMISSIONS ==================== */}
      <div className="submissions-section">
        <div className="submissions-header">
          <h2>Contact Form Submissions</h2>
        </div>

        {submissionMessage && (
          <div className={`submission-message ${submissionMessage.includes("success") ? "success" : "error"}`}>
            {submissionMessage}
          </div>
        )}

        <div className="submissions-table-card">
          {isLoadingSubmissions ? (
            <div className="loading-box"><div className="spinner" /><p>Loading submissions...</p></div>
          ) : submissions.length === 0 ? (
            <div className="empty-state">
              <span className="empty-icon">📭</span>
              <p>No submissions found</p>
            </div>
          ) : (
            <>
              <div className="table-wrapper">
                <table className="submissions-table">
                  <thead>
                    <tr>
                      <th>NAME</th>
                      <th>EMAIL</th>
                      <th>PHONE</th>
                      <th>SERVICE</th>
                      <th>MESSAGE</th>
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {submissions.map(s => (
                      <tr key={s.id}>
                        <td><span className="td-name">{getName(s)}</span></td>
                        <td>{getEmail(s)}</td>
                        <td>{getPhone(s)}</td>
                        <td>{getService(s)}</td>
                        <td><span className="td-message">{getMessage(s)}</span></td>
                        <td>
                          <div className="action-btns">
                            <button onClick={() => openModal(s)} className="btn-view">View</button>
                            <button onClick={() => handleDeleteSubmission(s.id)} className="action-btn">Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="pagination-bar">
                <div className="rows-per-page">
                  <label>Rows per page:</label>
                  <select value={itemsPerPage}
                    onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                  </select>
                </div>
                <div className="pagination-info">
                  ({(currentPage - 1) * itemsPerPage + 1}–
                  {Math.min(currentPage * itemsPerPage, totalCount)} of {totalCount})
                </div>
                <div className="pagination-btns">
                  <button onClick={goToPreviousPage} disabled={currentPage === 1} className="page-btn">‹</button>
                  <button onClick={goToNextPage} disabled={currentPage === totalPages} className="page-btn">›</button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* ==================== MODAL ==================== */}
      {isModalOpen && selectedSubmission && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Submission Details</h3>
                <p>{formatDate(selectedSubmission.createdAt)}</p>
              </div>
              <button className="modal-close" onClick={closeModal}>✕</button>
            </div>
            <div className="modal-body">
              <div className="modal-name-row">
                <div>
                  <h4>{getName(selectedSubmission)}</h4>
                  <p>{getEmail(selectedSubmission)}</p>
                </div>
              </div>
              <div className="modal-info-grid">
                <div className="modal-info-box">
                  <span className="info-label">📧 Email</span>
                  <span>{getEmail(selectedSubmission)}</span>
                </div>
                <div className="modal-info-box">
                  <span className="info-label">📞 Phone</span>
                  <span>{getPhone(selectedSubmission)}</span>
                </div>
              </div>
              <div className="modal-message-box">
                <h5>Message</h5>
                <p>{getMessage(selectedSubmission)}</p>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={() => handleDeleteSubmission(selectedSubmission.id)} className="btn-delete-modal">Delete</button>
              <button onClick={closeModal} className="btn-close-modal">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactManagement;